import React, { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals";
import LaddaButton from "../../../components/buttons/laddaButton";
import {
  callActionApiAsync,
  getBiomedicalEquipmentModelSummary,
  postDeleteBiomedicalEquipmentModel
} from "../../../services/apiService";
import ToastNotification from "../../../components/toastNotification";

const DeleteModelModal = ({ open, close, modelRow, userId, onDone }) => {
  const [showToast, setShowToast] = useState(false);
  const [toastConfig, setToastConfig] = useState({
    severity: "warning",
    summary: "",
    detail: ""
  });
  const [equipmentCount, setEquipmentCount] = useState(0);
  const [summaryLoading, setSummaryLoading] = useState(false);

  useEffect(() => {
    const loadSummary = async () => {
      if (!(open && modelRow?.value && userId)) return;
      setSummaryLoading(true);
      try {
        const { data } = await getBiomedicalEquipmentModelSummary(
          modelRow.value,
          userId
        );
        setEquipmentCount(
          typeof data?.equipmentCount === "number" ? data.equipmentCount : 0
        );
      } catch (err) {
        const detail =
          err?.response?.data?.error ||
          "No se pudo cargar la información del modelo.";
        setToastConfig({
          severity: "error",
          summary: "Error",
          detail
        });
        setShowToast(true);
      } finally {
        setSummaryLoading(false);
      }
    };

    if (open) {
      setEquipmentCount(0);
      loadSummary();
    }
  }, [open, modelRow, userId]);

  const handleClose = () => {
    setEquipmentCount(0);
    close();
  };

  const onDelete = async () => {
    if (!modelRow?.value) return;
    await callActionApiAsync(
      () =>
        postDeleteBiomedicalEquipmentModel({
          id: modelRow.value,
          userId
        }),
      () => {
        onDone?.();
        handleClose();
      },
      (error) => {
        setToastConfig({
          severity: "error",
          summary: "Error",
          detail:
            typeof error === "string" && error
              ? error
              : "No se pudo eliminar el modelo."
        });
        setShowToast(true);
      }
    );
  };

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title="Eliminar modelo"
        actions={<div className="HContainer j-center w-complete"></div>}
        maxWidth="640px"
      >
        <div className="HContainer">
          <div className="VContainer align-center m-20" style={{ maxWidth: "460px" }}>
            <p className="mb-15">
              ¿Eliminar el modelo <strong>{modelRow?.name}</strong>?
            </p>

            {summaryLoading && <p className="mb-15">Cargando resumen del modelo…</p>}

            {!summaryLoading && equipmentCount > 0 && (
              <div
                className="mb-15"
                style={{
                  padding: "10px 12px",
                  fontSize: "14px",
                  lineHeight: 1.45,
                  background: "#fff3e0",
                  borderRadius: "8px",
                  border: "1px solid #ffb74d"
                }}
              >
                No se puede eliminar este modelo porque está asociado a{" "}
                <strong>{equipmentCount}</strong> equipo(s) biomédico(s).
              </div>
            )}

            {!summaryLoading && equipmentCount === 0 && (
              <p className="mb-15" style={{ color: "#2e7d32" }}>
                No hay equipos usando este modelo. Puede eliminarlo.
              </p>
            )}

            <div className="HContainer j-center mt-20">
              <LaddaButton
                type="button"
                variant="contained"
                onClick={onDelete}
                disabled={summaryLoading || equipmentCount > 0}
              >
                Eliminar
              </LaddaButton>
            </div>
          </div>
        </div>
      </ModalComponent>
      <ToastNotification
        showToast={showToast}
        setShowToast={setShowToast}
        severity={toastConfig.severity}
        summary={toastConfig.summary}
        detail={toastConfig.detail}
      />
    </>
  );
};

export default DeleteModelModal;
